import Head from 'next/head'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import nextI18nextConfig from 'next-i18next.config'
import { Redirect } from 'lib/redirect'
import { localBusinessSchema, ogImage, siteUrl } from 'lib/seoConfigs'

export default function Index() {
  const router = useRouter()
  const currentLocale = Array.isArray(router.query.locale)
    ? router.query.locale[0]
    : router.query.locale || nextI18nextConfig.i18n.defaultLocale

  useEffect(() => {
    document.documentElement.lang = currentLocale.toString()
  }, [currentLocale])

  Redirect()

  const title = 'KROEMTECH | Schweizer Industrial IoT & Datenerfassung'
  const description =
    'KROEMTECH – Ihr Schweizer Partner für Industrial IoT. Plug-and-Play-Sensorik, sichere Datenerfassung und smarte Lösungen für KMU und Institutionen.'

  return (
    <Head>
      {/* Basic Meta */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta httpEquiv="content-language" content={currentLocale} />
      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />

      {/* Favicon */}
      <link rel="shortcut icon" href="/favicon.ico" />

      {/* Canonical */}
      <link rel="canonical" href={siteUrl} />

      {/* Hreflang for localization */}
      <link rel="alternate" hrefLang="de" href={`${siteUrl}/de/`} />
      <link rel="alternate" hrefLang="en" href={`${siteUrl}/en/`} />
      <link rel="alternate" hrefLang="x-default" href={`${siteUrl}/de/`} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD LocalBusiness */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(localBusinessSchema)
        }}
      />
    </Head>
  )
}

/*
className = {`${styles.main} ${inter.className}`
*/
